import React, {Fragment} from "react";
import {NavLink, useNavigate} from "react-router-dom";
import "./CowsMenu.scss";
import {ScrollBlock} from "../../../components/ScrollBlock/ScrollBlock";
import {ROOT_URL} from "../../../config/url";
import {ButtonIcon, useAction, useObject} from "@vokymlak/kabinet-ui";

export const CowsMenu = (props) => {
  const {
    setIsHiddenMenu,
    isHiddenMenu
  } = props

  const navigate = useNavigate();

  const {
    object: [object],
    update: [_isUpdateObject, _setIsUpdateObject, updateObject],
  } = useObject({apiUrl: "/api/cow-locations/view", rootUrl: ROOT_URL});

  useAction(["cows"], () => updateObject());

  const getLocationCount = (object, uuid) => {
    let count = null;
    if (!!object && !!object.cow_locations) {
      object.cow_locations.forEach(t => {
        if (t.uuid === uuid) {
          count = t.count_cows;
        }
      })
    }
    return count;
  }

  function isOnlyDashes(str) {
    return /^-+$/.test(str);
  }

  return (
    <ScrollBlock style={{width: "100%", height: "100%"}}>
      <div className="CowsMenu">
        <div className="Menu__header">
          <div className="Header__text" style={{
            display: "flex",
            alignItems: "center"
          }}>
            КРС

            <ButtonIcon
              tooltipText={"Настройки"}
              iconName={"custom-settings"}
              iconColor={"#20202033"}
              size={24}
              style={{marginLeft: 12}}
              onClick={() => navigate("/cows/locations")}
            />
          </div>

          <ButtonIcon
            iconName={"custom-circle-arrow-left"}
            iconColor={"#20202075"}
            size={24}
            style={{position: "absolute", right: 16, top: 20}}
            onClick={() => setIsHiddenMenu(!isHiddenMenu)}
          />
        </div>

        <ul className="Menu__list" style={{paddingBottom: 0}}>
          <li className="List__link">
            <NavLink
              className="Link__text"
              to={"/cows/all"}
            >
              Все
              {!!object && !!object.count_all_cows && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    ({object.count_all_cows})
                  </span>
              )}

              {!!object && !object.count_all_cows && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    (0)
                  </span>
              )}
            </NavLink>
          </li>
          <li className="List__link">
            <NavLink
              className="Link__text"
              to={"/cows/no-location"}
            >
              Без локации
              {!!object && !!object.count_no_cow_locations && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    ({object.count_no_cow_locations})
                  </span>
              )}

              {!!object && !object.count_no_cow_locations && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    (0)
                  </span>
              )}
            </NavLink>
          </li>
        </ul>

        <ul className="Menu__list" style={{paddingBottom: 0}}>
          <li className="List__link">
            <NavLink
              className="Link__text"
              to={"/cows/bull"}
            >
              Бык-производитель
              {!!object && !!object.count_bull_cows && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    ({object.count_bull_cows})
                  </span>
              )}

              {!!object && !object.count_bull_cows && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    (0)
                  </span>
              )}
            </NavLink>
          </li>
          <li className="List__link">
            <NavLink
              className="Link__text"
              to={"/cows/cow"}
            >
              Корова
              {!!object && !!object.count_cow_cows && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    ({object.count_cow_cows})
                  </span>
              )}

              {!!object && !object.count_cow_cows && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    (0)
                  </span>
              )}
            </NavLink>
          </li>
          <li className="List__link">
            <NavLink
              className="Link__text"
              to={"/cows/netel"}
            >
              Нетель
              {!!object && !!object.count_netel_cows && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    ({object.count_netel_cows})
                  </span>
              )}

              {!!object && !object.count_netel_cows && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    (0)
                  </span>
              )}
            </NavLink>
          </li>
          <li className="List__link">
            <NavLink
              className="Link__text"
              to={"/cows/heifer"}
            >
              Телка
              {!!object && !!object.count_heifer_cows && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    ({object.count_heifer_cows})
                  </span>
              )}

              {!!object && !object.count_heifer_cows && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    (0)
                  </span>
              )}
            </NavLink>
          </li>
          <li className="List__link">
            <NavLink
              className="Link__text"
              to={"/cows/steer"}
            >
              Бычок
              {!!object && !!object.count_steer_cows && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    ({object.count_steer_cows})
                  </span>
              )}

              {!!object && !object.count_steer_cows && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    (0)
                  </span>
              )}
            </NavLink>
          </li>
        </ul>

        {/*<ul className="Menu__list">*/}
        {/*  <li className="List__link">*/}
        {/*    <NavLink*/}
        {/*      className="Link__catalog"*/}
        {/*      to={"/cows/tracker"}*/}
        {/*    >*/}
        {/*      Трекер*/}
        {/*    </NavLink>*/}
        {/*  </li>*/}
        {/*</ul>*/}

        {!!object && (
          <ul className="Menu__list" style={{paddingBottom: 0}}>
            <div
              className={"List__title"}
              style={{opacity: .75, cursor: 'default', fontSize: 16}}
            >
              По локация

            </div>
            {!!object.cow_locations && object.cow_locations.map((item) => (
              <Fragment key={item.uuid}>
                <li className="List__link">
                  {isOnlyDashes(item.title) && (
                    <div
                      style={{
                        marginTop: 12,
                        marginBottom: 12,
                        backgroundColor: "#20202015",
                        height: 1,
                        width: "95%"
                      }}
                    >
                    </div>
                  )}
                  {!isOnlyDashes(item.title) && (
                    <NavLink
                      className="Link__text"
                      to={"/cows/location/" + item.uuid}
                    >
                      {item.title}
                      {!!getLocationCount(object, item.uuid) && (
                        <span style={{
                          marginLeft: 4,
                          opacity: .75,
                          fontSize: 12
                        }}>
                    ({getLocationCount(object, item.uuid)})
                  </span>
                      )}

                      {!getLocationCount(object, item.uuid) && (
                        <span style={{
                          marginLeft: 4,
                          opacity: .75,
                          fontSize: 12
                        }}>
                    (0)
                  </span>
                      )}
                    </NavLink>
                  )}
                </li>
              </Fragment>
            ))}
          </ul>
        )}

        <ul className="Menu__list" style={{paddingBottom: 0}}>
          <li className="List__link">
            <NavLink
              className="Link__text"
              to={"/cows/dropped"}
            >
              Выбывшие
              {!!object && !!object.count_dropped_cows && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    ({object.count_dropped_cows})
                  </span>
              )}

              {!!object && !object.count_dropped_cows && (
                <span style={{
                  marginLeft: 4,
                  opacity: .75,
                  fontSize: 12
                }}>
                    (0)
                  </span>
              )}
            </NavLink>
          </li>
        </ul>
      </div>
    </ScrollBlock>
  );
};
